import { render, staticRenderFns } from "./ArticleBodyBottom.vue?vue&type=template&id=16b5c144"
import script from "./ArticleBodyBottom.vue?vue&type=script&lang=ts"
export * from "./ArticleBodyBottom.vue?vue&type=script&lang=ts"
import style0 from "./ArticleBodyBottom.vue?vue&type=style&index=0&id=16b5c144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports